import * as Sentry from "@sentry/nextjs";
import { isSentryEnabled } from "@/lib/sentry/config";

// Allowed metric attribute keys (cardinality allowlist).
// Denylist (never emit): account_id, project_id, user_id, api_key, api_key_hash,
// client_ip, stripe_customer_id, request_id, hold_id, transaction_id.
const ALLOWED_ATTRIBUTE_KEYS = new Set([
  "model",
  "endpoint",
  "dialect",
  "stream",
  "routing",
  "outcome",
  "reason",
  "status_family",
  "status_code",
  "backend_host",
  "event_type",
  "operation",
  "global_mode",
  "limiter",
  "job",
  "queue",
  "token_type",
]);

type MetricAttributes = Record<string, string | number | boolean>;

const filterAttributes = (attributes?: MetricAttributes): MetricAttributes | undefined => {
  if (!attributes) {
    return undefined;
  }
  const filtered: MetricAttributes = {};
  for (const [key, value] of Object.entries(attributes)) {
    if (ALLOWED_ATTRIBUTE_KEYS.has(key)) {
      filtered[key] = value;
    }
  }
  return Object.keys(filtered).length > 0 ? filtered : undefined;
};

export const uiMetricCount = (name: string, value = 1, attributes?: MetricAttributes): void => {
  if (!isSentryEnabled()) {
    return;
  }
  Sentry.metrics.count(name, value, { attributes: filterAttributes(attributes) });
};

export const uiMetricDistribution = (
  name: string,
  value: number,
  unit: "millisecond" | "byte" | undefined,
  attributes?: MetricAttributes,
): void => {
  if (!isSentryEnabled()) {
    return;
  }
  Sentry.metrics.distribution(name, value, {
    unit,
    attributes: filterAttributes(attributes),
  });
};

export const uiMetricGauge = (name: string, value: number, attributes?: MetricAttributes): void => {
  if (!isSentryEnabled()) {
    return;
  }
  Sentry.metrics.gauge(name, value, { attributes: filterAttributes(attributes) });
};
